import script from "./InterestRateView.vue?vue&type=script&setup=true&lang=js"
export * from "./InterestRateView.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__